import { createIcon } from './createIcon'

export const DoubleChevronIcon = createIcon({
  displayName: 'DoubleChevron',
  viewBox: '0 0 10 7',
  path: [
    <path
      d="M3.53644 0.814083L1.03888 3.31164L3.53644 5.8092"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />,
    <path
      d="M8.33646 0.814083L5.8389 3.31164L8.33646 5.8092"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    />,
  ],
})
